import Experience from '../Experience'

import Cosmos from './Cosmos'
import Cards from './Cards'

export default class World {
  constructor() {
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.debug = this.experience.debug

    this.init()
  }

  init() {
    this.cosmos = new Cosmos()
    this.cosmos.createTimeline()
    this.cards = new Cards()
  }

  update(time = 0) {
    this.cosmos.update(time)
    this.cards.update(time)
  }

  resize() {

  }
}